import React from 'react';
import { connect } from 'react-redux'
import { Button, Input } from 'reactstrap'
import { MdCameraAlt } from 'react-icons/md'
import { IoIosArrowUp } from 'react-icons/io'

import { Container, Row, Col } from 'reactstrap';

import { fobiCore } from './FobiCore'
import { addVeranstaltungPanelSetVNR, addVeranstaltungPanelSetVNRPwd, fetchVeranstaltung, fetchVeranstaltungWithJWT } from './store/veranstaltungen/actions'
import AddVeranstaltungAlert from './components/AddVeranstaltungAlert';
import PortalVnrHinweis from './components/PortalVnrHinweis';
import VnrCredentialsScannerDialog from './components/VnrCredentialsScannerDialog';
import { getVeranstaltungsJWT } from './store/veranstaltungen/handler';

class AddVeranstaltungPanel extends React.Component {
	
constructor(props){
	super(props);
	this.state = {
		readyToFetch: false,
		vnr: "2760602019241910008",
		vnrpwd: "unknown",
		showScanDialog: false
	};
	this.initLocalVars();
}
initLocalVars(){
	this.flagFetchNewVNREnabled = false;
}
setShowScanDialog(showScanDialog){
	this.setState({showScanDialog});
}
render(){
	const {fetchCounter, vnr, vnrpwd, changeVNR, changeVNRPwd, loadVeranstaltung} = this.props;
	const zuklappbar = this.props.zuklappbar !== false;
	const vnrClassNameAddOn = (vnr.length ===0 || fobiCore.isVNR(vnr))?"":" is-invalid";
	const fetchButtonEnabled = fetchCounter === 0 && fobiCore.isVNR(vnr) && vnrpwd.length > 0;
	const fetchButtonColor = "secondary";
	return (
		<Container className="mt-2 mb-2">
			{/* Zuklappen gibt es nur, solange es etwas anderes zu sehen gibt: bei leerer Liste
			    haelt VeranstalterPage das Formular offen, ein Knopf wuerde sichtbar nichts tun.
			    Und es ist ein echter Knopf, kein klickbares SVG - sonst bliebe genau hier die
			    Tastaturluecke, die dieser Schritt an der Karte behebt. */}
			<h4>Veranstaltung hinzufügen{ zuklappbar &&
				<button type="button" className="btn btn-link p-0 ms-1 align-baseline"
					aria-label="Formular zum Hinzufügen schließen"
					onClick={(e) => this.props.toggleAddVNRPanel()}>
					<IoIosArrowUp fontSize="1.5em" color="orange" aria-hidden="true" ></IoIosArrowUp>
				</button>
			}</h4>
			<PortalVnrHinweis />
			<Row className="form-group">
				<Col lg className="mt-2 mb-2">
					<Row >
						<label className="col-sm-5 col-form-label text-sm-right" htmlFor="vnr">VNR</label>
        		<div className="col-sm-7">
							<Input id="vnr" placeholder='VNR oder Einrichtungstoken'
								className={"form-control" + vnrClassNameAddOn} required={true} valid={fobiCore.isVNR(vnr)} type="text" autoFocus = {!vnr}
            		onChange={(e) => changeVNR(e.target.value)} value={vnr} />
        		</div>
					</Row>
				</Col>
				<Col lg className="mt-2 mb-2">
					<Row >
						<label className="col-sm-5 col-form-label text-sm-right" htmlFor={this.id}>Passwort</label>
        		<div className="col-sm-7">
							{/* Steht schon eine VNR da - etwa aus einem Portal-Link -, gehoert der Fokus hierher.
							    `autoFocus` feuert nur beim Mount: das haelt nur, solange das Panel beim Oeffnen
							    erzeugt wird und die VNR vorher im Store steht (siehe applyVNR). Wer es dauerhaft
							    mountet, verliert den Fokus lautlos. */}
							<Input id="vnrpwd" className="form-control" required={true} type="password" placeholder='z.B. geheim'
            		onChange={(e) => changeVNRPwd(e.target.value)} value={vnrpwd} autoFocus = {!!vnr}/>
        		</div>
					</Row>
				</Col>
			</Row>
			<AddVeranstaltungAlert></AddVeranstaltungAlert>
			{/* Auf dem Telefon zwei volle Bloecke untereinander, ab sm nebeneinander rechtsbuendig.
			    Vorher standen sie in jeder Breite rechts, in unterschiedlichen Breiten und mit
			    p-2/my-2/ms-4 gegeneinander versetzt - auf schmalen Geraeten sah das unruhig aus,
			    weil zwei verschieden lange Knoepfe an einer Kante haengen. Der Abstand kommt jetzt
			    aus einem gap statt aus drei verschiedenen Randklassen.
			    Reihenfolge bleibt Scannen -> Hinzufuegen: der Scan fuellt die Felder, die er
			    darueber ausfuellt. */}
			<Row>
				<div className="col">
					<div className="d-grid gap-2 d-sm-flex justify-content-sm-end">
						<Button title="Zugangsdaten einscannen" color="secondary" outline
							onClick={ (e) => { this.setShowScanDialog(true);  }}>
							<MdCameraAlt size="1.5em" aria-hidden="true" ></MdCameraAlt>
							<span className="d-sm-none ms-2">Zugangsdaten aus Barcode</span>
						</Button>
						<Button  disabled={!fetchButtonEnabled} color={ fetchButtonColor }
							onClick={ (e) => loadVeranstaltung(vnr, vnrpwd) } >Veranstaltung hinzufügen
						</Button>
					</div>
				</div>
			</Row>
			{/* Ausserhalb der Knopfreihe: der Dialog ist ein Modal und haette dort nichts zu suchen. */}
			<VnrCredentialsScannerDialog isOpen={this.state.showScanDialog} toggle={() => this.setShowScanDialog(false)} />
			{this.props.children}
	</Container>
	);
	}
}

const mapStateToProps = function(state) {
  return { 
		vnr: state.addVeranstaltungPanel.vnr,
		vnrpwd: state.addVeranstaltungPanel.vnrpwd,
		fetchCounter: state.fetchCounter
	}
}

 const mapDispatchToProps = dispatch => ({
 	changeVNR: vnr => {
		const jwt = getVeranstaltungsJWT(vnr);
		if(jwt){
			dispatch(fetchVeranstaltungWithJWT(jwt));
		}
		dispatch(addVeranstaltungPanelSetVNR(vnr));
		
	},
	changeVNRPwd: vnrpwd => {
		const jwt = getVeranstaltungsJWT(vnrpwd);
		if(jwt){
			dispatch(fetchVeranstaltungWithJWT(jwt));
		}
		dispatch(addVeranstaltungPanelSetVNRPwd(vnrpwd));
	},
	loadVeranstaltung: (vnr, vnrpwd) => dispatch(fetchVeranstaltung(vnr, vnrpwd))
 })

export default connect(mapStateToProps, mapDispatchToProps)(AddVeranstaltungPanel) 